module.exports = __webpack_public_path__ + "img/news.298ecf1d.png";